<!-- START HEADER-->
<header class="header" app-property-header></header>
<!-- END HEADER-->
<!-- START SIDEBAR-->
<nav class="page-sidebar" id="sidebar" app-property-sidebar></nav>
<!-- END SIDEBAR-->

<!-- START PAGE CONTENT-->
<div class="content-wrapper">
    <router-outlet></router-outlet>
    <!-- <div app-banner></div> -->
    <footer class="page-footer" app-property-footer></footer>
</div>
